// Pathify
import {make} from 'vuex-pathify'
import api from "@/services/api";
import {toast} from '@/util/helpers';

// Data
const state = {
	users:[],
	user: {},
}

const getters = make.getters(state)

const mutations = make.mutations(state)

const actions = {
	...make.actions(state),
	getUsers: ({ dispatch }) => {
		api.users.index()
			.then(response => dispatch('setUsers', response.data))
			.catch(error => {
				console.log(error);
				toast.add(error.message, 'error')
			})
			.finally(()=>{
				dispatch('app/loading', false, { root: true })
			})
	},
	getUser: ({ dispatch }, id) => {
		api.users.show(id)
			.then(response => dispatch('setUser', response.data))
			.catch(error => toast.add(error.message, 'error'))
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
}
